import {Station} from "./Station";
import {Service} from "./Service";
import {Vehicle} from "./Vehicle";
import {Fuel} from "./Fuel";
import {User} from "./User";
import {QuadrantLineHour} from "./QuadrantLineHour";
import {Hour} from "./Hour";
import {PaymentMethod} from "./PaymentMethod";
import {AvailableHour} from "./AvailableHours";

export interface Reservation {
  id: number;
  quadrant_line_hour_id: number;
  station_id: number;
  service_id: number;
  vehicle_id: number;
  fuel_id: number;
  payment_method_id:number;
  registration_number: string;
  date: string;
  station: Station,
  service: Service,
  vehicle: Vehicle,
  fuel: Fuel,
  user: User,
  payment_method: PaymentMethod,
  professional: any,
  professional_id?:number,
  locked:boolean,
  state: boolean,
  paid:boolean,
  phone: string,
  email:string,
  name:string,
  /*quadrant_line_hour:QuadrantLineHour,*/
  hour: Hour,
  created_at: string;
  cancel_at: string;
  updated_at: string;
  deleted_at: string;
  stolen?: boolean;
  ip: string;
  lightweight_vehicle?: boolean;
  heavy_vehicle_over?: boolean;
  diesel?: boolean;
  farm_type?: string;
  second_inspection?: SecondInspection;
}

export interface ReservationCanceled {
  id: number;
  quadrant_line_hour_id: number;
  station_id: number;
  service_id: number;
  vehicle_id: number;
  fuel_id: number;
  payment_method_id:number;
  registration_number: string;
  date: string;
  station: Station,
  service: Service,
  vehicle: Vehicle,
  fuel: Fuel,
  user: User,
  payment_method: PaymentMethod
  state: boolean,
  phone: string,
  email:string,
  /*quadrant_line_hour:QuadrantLineHour,*/
  hour: string,
  created_at: string;
  cancel_at: string;
  updated_at: string;
  deleted_at: string;
}


export interface OldReservation{
  registration_number: string;
  date: string;
  station: Station,
  service: Service,
  vehicle: Vehicle,
  fuel: Fuel,
  hour: AvailableHour,
  expiration: string,
  expired?: boolean,
  stolen: boolean
}
export enum SecondInspection {
  Contaminacion = 'contaminacion',
  Seguridad = 'seguridad',
  Ambos = 'ambos',
}

